<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="Particulares" />
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Cuenta Privada WI··')"
          subtitle=""
          :ctaText="$t('Apertura de cuenta')"
          ctaTarget="https://ecobanka.com/cuenta-privada-wi%c2%b7%c2%b7/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-Empezar.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Tarjeta Débito WI··')"
          :ctaText="$t('Solicitar Tarjeta wI--')"
          ctaTarget="https://ecobanka.com/tarjeta-debito- wi%c2%b7%c2%b7/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-close-up-of-female-hands-making-online-payment.jpg"
        ></dashboard-banner-tile>
      </div>
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          :title="$t('Hipotecas ALTERNATIVE')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://ecobanka.com/hipoteca-alternative-plus/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-agente-corredores-bienes-raices-que-presenta-consulta-cliente-toma-decisiones-firmar-acuerdo-seguro_1150-15017.jpg"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          :title="$t('Préstamo Multibanka')"
          :ctaText="$t('Acceder')"
          ctaTarget="https://ecobanka.com/prestamo-multibanka/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-07-31-Comprar%20auto.jpg"
        ></dashboard-banner-tile>
      </div>
    </div>
  </section>
</template>
<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'PrivateUsers',
  components: {
    AdminSectionHeader,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Particulares'],
      title: 'Particulares'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
